/** Text-only names shown in “trusted by” marquees (no image assets). */
export const CLIENT_LOGO_NAMES = [
  'ReNew',
  'Sembcorp',
  'STL',
  'Zafco',
  'Care N Cure',
  'Suzlon',
  'O2 Power',
  'JSW Energy',
  'Ideaforge',
  'AWS',
  'WTI Cabs',
  'DB RRTS',
  'Siemens',
  'Alstom',
] as const;
